import React from "react";

/**
 * Drop-in component to keep a page out of search engines.
 *
 * Usage:
 *   import NoIndex from "@/components/NoIndex";
 *   export default function ThankYou() {
 *     return (<><NoIndex />... rest of page ...</>);
 *   }
 *
 * React 19 hoists `<meta>` / `<title>` / `<link>` tags rendered inside any
 * component up to the document <head> automatically, so this works without
 * react-helmet or any other library.
 *
 * Reach for this on any page that's:
 *   - only meaningful after a form submission (e.g. /thank-you, /confirmed)
 *   - an internal preview / admin surface
 *   - a transient marketing landing we don't want indexed yet
 */
export default function NoIndex({ title }) {
  return (
    <>
      <meta name="robots" content="noindex, nofollow" />
      {title ? <title>{title}</title> : null}
    </>
  );
}
